import { Copy, Help, SystemText } from 'e4shared';
import React from 'react';

export const Correlation = ({ value, widget }) => {
    const mapCorrelation = x => {
        if (x < -0.5) return SystemText('General/Correlation/StrongNegative');
        if (x < -0.3) return SystemText('General/Correlation/MediumNegative');
        if (x < -0.1) return SystemText('General/Correlation/WeakNegative');
        if (x < 0.1) return '';
        if (x < 0.3) return SystemText('General/Correlation/WeakPositive');
        if (x < 0.5) return SystemText('General/Correlation/MediumPositive');
        return SystemText('General/Correlation/StrongPositive');
    };

    let correlation = mapCorrelation(value);
    return (
        <div data-testid="text-correlation">
            {correlation ? (
                <Copy
                    value={SystemText('General/Correlation/Explained', correlation, (isNaN(value) ? 0 : value).toFixed(3))}
                />
            ) : (
                <span>{SystemText('General/Correlation/None')}</span>
            )}
            <Help id={`correlation-help-${widget.id}`}>
                <div>
                    <Copy value={SystemText('General/Correlation/Help')} />
                </div>
            </Help>
        </div>
    );
};

export default Correlation;
